import { usePathname } from 'next/navigation';

export const useFixedHeader = (locale: string) => {
  const pathname = usePathname();
  const isFixedHeader =
    pathname === '/' ||
    pathname === `/${locale}` ||
    pathname.includes('/games');

  return isFixedHeader;
};
